import React from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty, filter } from 'lodash';
import ReviewSpaceRentalTable from '../elements-tables/review-space-rental-table';
import AddOnsTable from '../app-main/components/reduxForms/fieldSets/AddOnsTable/add-ons-table';
import PayoutTable from '../elements-tables/payout-table';
import CustomOfferWhatsNext from './custom-offer-whats-next';

const ReviewOfferHostView = ({
  cleaningFee,
  currency,
  handleWithdrawOfferClick,
  redirectToInboxDetails,
  isSubmitting,
  masterContract,
  itemsArray,
  guestFee,
  hostFee,
  guestPayment,
  hostPayout,
  hostId,
  contract,
  isHostUpdate,
  addOnsTotal,
  total,
  spaceRentalSubtotal,
  spaceRentalTotal,
  discounts,
  hostAddOnsSummary = {}
}) => {
  const masterCalc  = get(masterContract, 'calculations', {});
  const hasConciergeItems = get(masterCalc, 'concierge_add_ons_summary', false);

  const displayAddOns = get(masterCalc, 'host_add_ons_summary') ||
    (addOnsTotal && !hasConciergeItems)

  return (
    <div className="ReviewOfferHostView">
      <div className="tables flex column">
        <ReviewSpaceRentalTable
          cleaningFee={cleaningFee}
          currency={currency}
          subtotal={spaceRentalSubtotal}
          total={spaceRentalTotal}
          masterContract={masterContract}
        />

        {
          !!displayAddOns &&
            <AddOnsTable
              isReviewPage
              addOnsTotal={addOnsTotal}
              hostAddOnsSummary={hostAddOnsSummary}
              itemsArray={itemsArray}
              currency={currency}
              contract={contract}
              masterContract={masterContract}
              ssoId={hostId}
            />
        }

        <PayoutTable
          currency={currency}
          spaceRentalTotal={spaceRentalTotal}
          addOnsTotal={addOnsTotal}
          hostAddOnsSummary={hostAddOnsSummary}
          total={total[hostId]}
          guestPayment={guestPayment}
          hostPayout={hostPayout}
          guestFee={guestFee}
          hostFee={hostFee}
          itemsArray={itemsArray}
          discounts={discounts}
          masterContract={masterContract}
        />

        <CustomOfferWhatsNext
          handleWithdrawOfferClick={handleWithdrawOfferClick}
          redirectToInboxDetails={redirectToInboxDetails}
          isSubmitting={isSubmitting}
          isHostUpdate={isHostUpdate}
        />
      </div>
    </div>
  );
};

ReviewOfferHostView.propTypes = {
  cleaningFee: PropTypes.string,
  currency: PropTypes.string,
  handleWithdrawOfferClick: PropTypes.func,
  redirectToInboxDetails: PropTypes.func,
  isSubmitting: PropTypes.bool,
  masterContract: PropTypes.object,
  itemsArray: PropTypes.array,
  hostId: PropTypes.string,
  contract: PropTypes.object,
  addOnsTotal: PropTypes.number,
  total: PropTypes.object,
  spaceRentalSubtotal: PropTypes.number,
  spaceRentalTotal: PropTypes.number,
  isHostUpdate: PropTypes.bool,
  guestFee: PropTypes.number,
  hostFee: PropTypes.number,
  guestPayment: PropTypes.number,
  hostPayout: PropTypes.number,
  discounts: PropTypes.object
};

export default ReviewOfferHostView;
